module.exports = __webpack_public_path__ + "static/img/weather61.6ae3c570.png";